module.exports = __webpack_public_path__ + "assets/google-sheet-list.d7c8158a.svg";